<template>
  <div id="data-list-list-view-expressions">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Language</label>
          <v-select :options="languages" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="libelle" v-model="input.language" class="w-full" />                
          <!-- <vs-input v-model="input.nom" class="w-full" /> -->
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <!-- <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="submitData" class="mt-5">Enrégistrer</vs-button> -->
        </div>
      </div>
    </vx-card>

    <vs-table ref="table" search :data="traductions">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Ajouter</vs-button>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ param.paginate.page * param.paginate.length - (param.paginate.length - 1) }} - {{ taille - param.paginate.page * param.paginate.length > 0 ? param.paginate.page * param.paginate.length : taille }} {{ $t("of_sur") }} {{ taille }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item :key="indexItem" v-for="(item, indexItem) in itemsPerPages" @click="param.paginate.length=item, getTraductions()">
              <span> {{item}} </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="expression.libelle">Expression</vs-th>
        <vs-th sort-key="libelle">Translation</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.expression.libelle }}</p>
            </vs-td>

            <vs-td>
              <div class="vx-row">
                <vs-input v-model="tr.libelle" class="w-full" />
              </div>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Supprimer" color="danger">
                  <feather-icon
                    @click="traduction_delete(tr)"
                    style="color: red"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>

              </div>
            </vs-td>

          </vs-tr>
        </tbody>   
        
        <vs-button :disabled="!traductions.length" class="mt-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="submitData">Save Changes</vs-button>
      </template>

    </vs-table>
    <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
let base_self = ''
import vSelect from 'vue-select'
import DataViewSidebar from './DataViewSidebar.vue'
// import moduleDataList from '@/store/data-list/moduleDataList.js'
import i18nDataForESM from '@/i18n/i18nDataForESM'

// const i18nDataForESM = {}

const input_tempon = {
  language: ''
}

export default {
  components: {
    DataViewSidebar, vSelect
  },
  data () {
    return {
      param: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
        }
      },
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      all_language: {},
      setting: {},
      length: 50000,
      page: 1,
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      selected: [],
      traductions: [],
      languages: [],
      itemsPerPage: 5000,
      isMounted: false,

      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    filterExpression () {
      const data = Object.keys(i18nDataForESM.en)
      const length = data.length
      const filterData = []

      for (let i = 0; i < length; i++) {
        if (!base_self.all_language.en[data[i]]) {
          filterData.push(data[i])
        }
      }

      /* console.log('data: ', data)
      console.log('filterData: ', filterData) */
      if (filterData.length) {
        base_self.createExpressionForFile(filterData)
      }
    },
    createExpressionForFile (data) {
      base_self.$vs.loading()
      const expressions = []
      const length = data.length

      for (let i = 0; i < length; i++) {
        const item = data[i]
        const traduction = []
        const libelle = i18nDataForESM.en[item]

        for (let j = 0; j < base_self.languages.length; j++) {
          traduction.push({
            libelle,
            language: base_self.languages[j].id
          })
        }

        expressions.push({
          libelle: item,
          traduction
        })
      }

      /* 
      {
        libelle: '',
        traduction: [
          {
            libelle: '',
            language: ''
          }
        ]
      }
      */

      // console.log('expressions: ', expressions)

      base_self.$http.post(`${base_self.$store.state.route_for_account}expression`, { many: true, data: expressions })
        .then((response) => { 
          window.getESM.success('The expressions are added successfully.', response)
          base_self.$vs.loading.close()
          window.getESM.initI18n()
          // base_self.save_all_language()
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    async submitData () {
      const traductions = JSON.parse(JSON.stringify(base_self.traductions))

      const all_language = {}

      const length = traductions.length
      for (let i = 0; i < length; i++) {
        all_language[traductions[i].expression.libelle] = traductions[i].libelle
        delete traductions[i].expression
        delete traductions[i].language
      }

      base_self.updateTranslation(traductions)
    },
    /* async save_all_language () {
      base_self.$http.get(`${base_self.$store.state.route_for_esm}set-setting`, base_self.setting)
        .then((response) => {
          console.log('response: ', response)
          window.getESM.initI18n()
          base_self.getSettings()
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    }, */
    async updateTranslation (traductions) {
      base_self.$vs.loading()
      base_self.$http.put(`${base_self.$store.state.route_for_account}traduction`, { data: traductions, many: true })
        .then((response) => { 
          base_self.$vs.loading.close()
          window.getESM.success('All translations is modified successfully.', response)
          window.getESM.initI18n()
          // base_self.save_all_language()
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    async getLanguages () {
      const param = {}
      const response = await base_self.$http.get(`${base_self.$store.state.route_for_account}langue`, param)
      base_self.languages = response.data.data
      base_self.getSettings()
    },
    async getSettings () {
      const data = {
        is_get: true,
        paginate: {
          length: 1,
          page: 1
        },
        filter: { 
          unique__contains: 'unique'
        }
      }

      const response = await base_self.$http.post(`${base_self.$store.state.route_for_account}Settings`, data)
        .catch((error) => { 
          console.log('error: ', error)
        })
        
      base_self.setting = response.data.data[0]
      
      base_self.$http.get(`${base_self.$store.state.route_for_esm}get-all-expresion`)
        .then((response) => {
          base_self.all_language = response.data.data

          // console.log('base_self.all_language: ', base_self.all_language)
          base_self.filterExpression()
        })
        .catch((error) => { 
          console.log('error: ', error)
        })

    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    edit (data) {
      base_self.sidebarData = JSON.parse(JSON.stringify(data))
      // base_self.detail__detail = false;
      base_self.toggleDataSidebar(true)
    },
    async traduction_delete (tr) {
      
      base_self.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          base_self.searchAllTranslation(tr)
        }
      })
    },
    async searchAllTranslation (tr) {
      const data = {
        filter: {
          state: true
        }
      }

      data['filter']['expression__id'] = tr.expression.id

      const param = {
        // simple: true,
        data: JSON.stringify(data),
        is_json: '0'
      }

      const response = await base_self.$http.get(`${base_self.$store.state.route_for_account}traduction`, { params: param })
      base_self.deleteSelectionTranslation(response.data.data)
    },
    async deleteSelectionTranslation (traductions) {
      const length = traductions.length
      for (let i = 0; i < length; i++) {
        delete traductions[i].expression
        delete traductions[i].language
        traductions[i].state = false
      }

      base_self.$vs.loading()
      base_self.$http.put(`${base_self.$store.state.route_for_account}traduction`, { data: traductions, many: true })
        .then((response) => { 
          base_self.$vs.loading.close()
          window.getESM.success('The translation is deleted successfully.', response)
          base_self.getTraductions()
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    async getTraductions () {
      if (base_self.input.language && base_self.input.language.id) {
        base_self.$vs.loading()
        const language = base_self.input.language.id
        
        base_self.param['filter']['language__id'] = language

        const response = await base_self.$http.post(`${base_self.$store.state.route_for_account}traduction`, base_self.param)

        base_self.traductions = response.data.data
        base_self.taille = response.data.taille
        base_self.$vs.loading.close()
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'admin') return 'warning'
      if (status === 'director') return 'primary'
      if (status === 'manager') return 'success'
      if (status === 'agronomist') return 'danger'
      return 'dark'
    },
    getPopularityColor (num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  watch: {
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getTraductions()
    },
    input: {
      handler () {
        if (base_self.input.language && base_self.input1.language.id !== base_self.input.language.id) {
          base_self.getTraductions()
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
      },
      deep: true
    }
  },
  created () {
    window.getAppTraductions = this
    base_self = this
    base_self.getLanguages()

    // console.log('i18nDataForESM: ', i18nDataForESM)

    /* if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems') */
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">

</style>
